import { Curves } from './icons/Curves'
import Styles from './DragAndDropZone.module.scss'
import { YouTube } from './icons/YouTube'
import { Square } from './icons/Square'

export const DragAndDropZone = () => {
  return (
    <div className={Styles.dropZone}>
      <div className={Styles.innerContainer}>
        <div className={Styles.logosAndText}>
          <div className={Styles.logos}>
            <Square />
            <YouTube className={Styles.youTube} />
            <Curves />
          </div>
          <div className={Styles.text}>
            <span>Drag & Drop</span>
            <span>
              <span className={Styles.blueText}>Image</span>, <span className={Styles.blueText}>Video</span> &{' '}
              <span className={Styles.blueText}>Audio</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
